<template lang="pug">
div
  .top-line
    .left
      h2
        input.name-element(
          v-show="editName"
          key=1
          ref="input"
          v-model="innerName"
          @blur="editName = false"
          @keyup.enter="editName = false")
        span.name-element(v-show="!editName" key=2) {{ innerName }}
      // edit classification name disabled for now
      // button.edit-name-button(type="button" @click="toggleEditName")
        briq-icon(name="icon-input-edit-icon")
    BriqButton(variant="secondary" small @click="newSegment" v-if="canCreateSegments" data-test-id="add-segment-button") + Add segment
  table(v-if="hasSegments").table.table--form
    thead
      tr
        th Order
        th Color
        th Name - single
        th Name - plural
        th Description
        th Status
        th
    draggable(tag="tbody" :list="classification.segments" id="visitor-segments" handle=".handle" v-bind="dragOptions" @end="reorder")
      SegmentRow(v-for="segment in segments" :key="segment.code" :segment="segment" :classification="classification" :canEditSegments="canEditSegments")
  span(v-else) This classification does not have any segments yet.
</template>

<script>
import draggable from 'vuedraggable'
import SegmentRow from '@/vue/settings/application/visitorclassifications/SegmentRow.vue'
import VisitorClassificationService from '@/vue/settings/application/visitorclassifications/VisitorClassificationService.js'

export default {
  components: { SegmentRow, draggable },
  props: {
    canCreateSegments: Boolean,
    canEditSegments: Boolean,
    classification: {
      type: Object,
      validator: c => c.name && c.code && c.segments !== undefined,
      required: true,
    },
  },
  data() {
    return {
      editName: false,
      innerName: this.classification.name,
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
      },
    }
  },
  computed: {
    segments() {
      return this.classification && this.classification.segments
    },
    hasSegments() {
      return this.segments && this.segments.length > 0
    },
  },
  methods: {
    toggleEditName() {
      this.editName = !this.editName
      if (this.editName) this.$nextTick(() => this.$refs.input.focus())
    },
    reorder() {
      this.classification.segments.forEach((segment, indx) => {
        const currentOrder = segment.order
        segment.order = indx + 1
        if (currentOrder !== segment.order) {
          VisitorClassificationService.updateSegment(this.classification.code, segment)
        }
      })
    },
    newSegment() {
      this.$router.push({
        name: 'SegmentNew',
        params: {
          classificationCode: this.classification.code,
        },
      })
    },
  },
  watch: {
    classification(newVal) {
      this.innerName = newVal.name
    },
  },
}
</script>

<style scoped lang="stylus">
.top-line
  display flex
  justify-content space-between
  margin-bottom 1em

.edit-name-button
  cursor pointer
  background transparent
  border none
  height 100%
  vertical-align top
  display inline-block

h2
  display inline-flex
  align-items center
  margin-right .4em
  line-height 1.4

table
  width 100%

tr
  background white

tr:nth-of-type(even)
  background #f8f9fa

th
  padding 10px 20px

th:nth-child(1), th:nth-child(2)
  width 8em

.name-element
  display inline-flex
  align-items center
  overflow hidden
  height 34px

span.name-element
  width 100%

input.name-element
  width 232px
  outline none
  padding-left 5px
</style>
